export enum BackgroundVisitUploadStatus {
  PENDING = "Pending",
  UPLOADING = "Uploading",
  DONE = "Done",
  CANCELLED = "Cancelled",
  FAILED = "Failed",
}
